import React from 'react';

import { DesktopConnectedView } from './components/desktop-connected-view';

export const DesktopConnected: React.FC = () => <DesktopConnectedView />;
